import React from 'react';
import { useParams } from 'react-router-dom';
import './Templates.css';

const TemplateViewer = () => {
    const { templateId } = useParams();

    const templateMapping = {
        'agent-base': '/templates/agent-templates/base/build/index.html',
        'agent-luxury': '/templates/agent-templates/luxury/build/index.html',
        'agent-metropolitan': '/templates/agent-templates/metropolitan/build/index.html',
        'agent-skyline': '/templates/agent-templates/skyline/build/index.html',
        'agent-futuristic': '/templates/agent-templates/futuristic/build/index.html',
        'agent-vibrance': '/templates/agent-templates/vibrance/build/index.html',
        'brokerage-base': '/templates/brokerage-templates/base/build/index.html',
        'brokerage-luxury': '/templates/brokerage-templates/luxury/build/index.html',
        'brokerage-metropolitan': '/templates/brokerage-templates/metropolitan/build/index.html',
        'brokerage-skyline': '/templates/brokerage-templates/skyline/build/index.html',
        'brokerage-vibrance': '/templates/brokerage-templates/vibrance/build/index.html',
        'brokerage-futuristic': '/templates/brokerage-templates/futuristic/build/index.html',
        'landing-base': '/templates/landing-templates/base/build/index.html',
        'landing-condo': '/templates/landing-templates/condo/build/index.html',
        'landing-townhouse': '/templates/landing-templates/townhouse/build/index.html',
        'landing-multiplex': '/templates/landing-templates/multiplex/build/index.html',
    };

    const templateUrl = templateMapping[templateId];

    if (!templateUrl) {
        return <div className="template-not-found">Template not found.</div>;
    }

    return (
        <div className="template-viewer-container">
            <iframe
                src={templateUrl}
                title={templateId}
                className="template-viewer-iframe"
            />
        </div>
    );
};

export default TemplateViewer;
